import React, { useState, useEffect } from "react";
import { Table, Space, Button, Row, Col, Select, Input, notification, Modal, Tooltip, Pagination } from "antd";
import { EditOutlined, FilePdfOutlined, EyeOutlined, DeleteOutlined, SearchOutlined } from "@ant-design/icons";
import { Link } from "react-router-dom";
import { loadingPlanService } from "../../../services";
import { checkPermission } from "../../../utils/permissions";
import { useDebounce } from "../../../hooks/useDebounce";
import { changeDocumentTitle } from "../../../utils/title";

function SaveContainer() {

  const [loading, setLoading] = useState(false);
  const [deleteLoading, setDeleteLoading] = useState(false);
  const [savedPlan, setSavedPlan] = useState([]);
  const [isModalshow, setIsModalShow] = useState(false);
  const [selectedDeleteRecord, setSelectedDeleteRecord] = useState(null);
  const [search, setSearch] = useState(null);
  const [pagination, setPagination] = useState({
    current: 1,
    total: 0,
    pageSize: 10,
  });
  const debouncedSearch = useDebounce(search, 500);

  const columns = [
    {
      title: "#",
      dataIndex: "#",
      key: "_id",
      render: (text, record, index) => ((pagination.current - 1) * 10) + index + 1
    },
    {
      title: "Container ID",
      dataIndex: "container_id",
      key: "ContainerID",
    },
    {
      title: "Container Number",
      dataIndex: "c_container_number",
      key: "ContainerNumber",
    },
    {
      title: "Booking Number",
      dataIndex: "c_booking_number",
      key: "c_booking_number",
    },
    {
      title: "Location",
      dataIndex: "location",
      key: "Location",
    },

    {
      title: "Actions",
      key: "Actions",
      render: (text, record) => (
        <Space direction="horizontal" size="small">
          <Space size="small">
            <Link
              to={`/operations/loadings/save-containers/edits/${record.container_id}`}
              className="hover:text-primary"
            >
              <Tooltip title='Edit'>
                {/* <Button type="primary" size="small"> */}
                <EditOutlined />
                {/* </Button> */}
              </Tooltip>
            </Link>

            <Link
              to={`/operations/loadings/save-containers/views/${record.container_id}`}
              className="hover:text-primary"
            >
              <Tooltip title='View'>
                {/* <Button type="primary" size="small"> */}
                <EyeOutlined />
                {/* </Button> */}
              </Tooltip>
            </Link>

            {checkPermission("DELETE_LOADPLAN") && <Tooltip title='Delete'>
              {/* <Button type="primary" size="small" onClick={() => showModal(record)}> */}
              <DeleteOutlined onClick={() => showModal(record)} />
              {/* </Button> */}
            </Tooltip>}

            <Link
              to={`/operations/loadings/generates-plans/${record.container_id}`}
              className="hover:text-primary"
            >
              <Tooltip title='Pdf'>
                <FilePdfOutlined />
              </Tooltip>
            </Link>


            <Link to={`/operations/bl-forms/add/${record.c_booking_number}`} className="hover:text-primary">
              <Button type="default" size="small">
                Doc Receipt
                {/* <FileAddOutlined /> */}
              </Button>
            </Link>
          </Space>

          {record.isDockReceiptGenerated && (
            <span
              style={{
                color: "red",
                fontWeight: "bold",
                border: "1px solid #ccc",
                padding: 5,
              }}
            >
              "Dock Receipt Generated"
            </span>
          )}
        </Space>
      ),
    },
  ];

  const showModal = (record) => {
    setSelectedDeleteRecord(record);
    setIsModalShow(true);
  };

  const handleCancel = () => {
    setIsModalShow(false);
    setSelectedDeleteRecord(null);
  };

  const handleDelete = async () => {
    if (!selectedDeleteRecord || !selectedDeleteRecord.container_id) {
      console.error("No entry selected for deletion.");
      return;
    }
    setDeleteLoading(true)
    const response = await loadingPlanService.deletePlan(
      selectedDeleteRecord.container_id
    );
    setDeleteLoading(false)
    if (response.success) {
      notification.success({
        message: "Delete Successfully!",
        description: response.message,
        placement: "topRight",
      });
      initialize(pagination.current, pagination.pageSize);
    } else {
      console.error("Failed to delete the customer.");
    }
    setIsModalShow(false);
  };

  const initialize = async (page = 1, pageSize = pagination.current) => {
    try {
      setLoading(true);

      const { success, data, message } = await loadingPlanService.fetchsaved(
        page, pageSize, debouncedSearch
      );

      if (success) {
        if (data && data.data && data.data.length > 0) {
          setSavedPlan(data.data);
          setPagination((prev) => ({
            ...prev,
            total: data.total,
            current: page,
            pageSize,
          }));
        } else {
          console.warn("No saved plans found.");
          setSavedPlan([]);
        }
      } else {
        console.error(`Error: ${message || "Failed to fetch saved plans."}`);
      }
    } catch (error) {
      console.error("An unexpected error occurred:", error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    changeDocumentTitle("Saved Plans");
    initialize(pagination.current, pagination.pageSize);
  }, [debouncedSearch]);
  return (
    <div
      style={{
        padding: "5px",
        border: "1px solid #ccc",
        borderRadius: "8px",
        backgroundColor: "#FFFFFF",
      }}
    >

      <div className="flex justify-between items-center">
        <h1 style={{ fontWeight: "bold" }} className="pl-2 pt-3">
          Browse Saved Plans
        </h1>
        <Input
          placeholder="Search by Container id & Container no"
          prefix={<SearchOutlined />}
          style={{
            width: "33%",
            borderRadius: "20px",
            fontSize: 14,
            margin: 10
          }}
          onChange={(e) => setSearch(e.target.value)}
        />
      </div>

      <Table
        columns={columns}
        scroll={{ x: "max-content" }}
        dataSource={savedPlan}
        rowKey="container_id"
        loading={loading}
        style={{ marginTop: "10px" }}
        // pagination={{
        //   current: pagination.current,
        //   total: pagination.total,
        //   pageSize: pagination.pageSize,
        //   onChange: (page) => initialize(page, pagination.pageSize),
        //   showSizeChanger: false,
        // }}
        pagination={false}
        footer={() => (
          <div className="flex justify-between items-center text-xs ">
            <div className=" text-gray-600">
              Showing {(pagination.current - 1) * pagination.pageSize + 1} to{" "}
              {Math.min(pagination.current * pagination.pageSize, pagination.total)} of{" "}
              {pagination.total} entries
            </div>
            <Pagination
              current={pagination.current}
              total={pagination.total}
              pageSize={pagination.pageSize}
              showSizeChanger={false}
              onChange={(page) => initialize(page, pagination.pageSize, search)}
              itemRender={(current, type, originalElement) => {
                if (type === "prev") return <a className="bg-[#EEEEEE] p-2 rounded-sm hover:text-primary">Previous</a>;
                if (type === "next") return <a className="bg-[#EEEEEE] p-2 rounded-sm hover:text-primary">Next</a>;
                return originalElement;
              }}
            />
          </div>
        )}
      />
      <Modal
        title={<div style={{ textAlign: "center" }}>Confirm</div>}
        open={isModalshow}
        onOk={handleDelete}
        onCancel={handleCancel}
        centered
        styles={{
          body: {
            padding: "20px",
          },
        }}
        width={300}
        footer={
          <div className="flex justify-center gap-3">
            <Button
              type="default"
              onClick={handleCancel}
              style={{ width: "30%" }}
            >
              Cancel
            </Button>
            <Button
              type="primary"
              onClick={handleDelete}
              loading={deleteLoading}
              style={{ width: "30%" }}
            >
              Confirm
            </Button>
          </div>
        }
      >
        <p style={{ textAlign: "center" }}>
          Are you sure you want to delete this?
        </p>
      </Modal>
    </div>
  );
}
export default SaveContainer;
